import { Component, OnInit } from '@angular/core';
import { InventoryService } from '../inventory.service';
import { GlobalResponse, Drug, Clinic, User } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { MatDialogRef, MatDialog } from '@angular/material';
import { CommonService } from '@app/shared-module/common-service.service';
import { Subject } from 'rxjs';
import { UploadDialogComponent } from '@app/shared-module/upload-dialog/upload-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { CreateDrugDialogComponent } from '../create-drug-dialog/create-drug-dialog.component';
import { ConsumeDialogComponent } from '../consume-dialog/consume-dialog.component';
import { debounceTime } from 'rxjs/operators';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-inventory-dashboard',
  templateUrl: './inventory-dashboard.component.html',
  styleUrls: ['./inventory-dashboard.component.css'],
})
export class InventoryDashboardComponent implements OnInit {
  drugCategory: string;
  clinicList: Clinic[] = [];
  pageNumber = 0;
  pageSize = 10;
  inventoryList: Drug[] = [];
  length = 0;
  bulkUploadURL = Constants.BULK_UPLOAD_URL;
  clinicID: string;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  searchBox: string;
  categoryList: string[] = [];
  currentItem: Drug;
  clinic_selected: any;
  user: User;
  isEditEnabled = false;
  @BlockUI() blockUI: NgBlockUI;

  private delaySubject = new Subject<string>();

  uploadDialogRef: MatDialogRef<UploadDialogComponent>;
  createDialogRef: MatDialogRef<CreateDrugDialogComponent>;
  consumeDialogRef: MatDialogRef<ConsumeDialogComponent>;

  constructor(
    private service: InventoryService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.drugCategory = Constants.ALL_INVENTORY_VALUE;
    this.getClinicList();
    this.user = this.commonService.internalLoginValue;
    if (
      this.user &&
      this.user.role &&
      (this.user.role === Constants.ROLE_ADMIN ||
        this.user.role === Constants.ROLE_MARKETING)
    ) {
      this.isEditEnabled = true;
    } else {
      this.isEditEnabled = false;
    }
    this.delaySubject.pipe(debounceTime(500)).subscribe((searchTextValue) => {
      this.categoryChanged(true, searchTextValue);
    });
  }

  categoryChanged(resetNumber: boolean, searchItem: string = '') {
    if (this.drugCategory) {
      // console.log(this.drugCategory);
      if (resetNumber) {
        this.pageNumber = 0;
        this.pageSize = 10;
        this.searchBox = '';
      }
      this.blockUI.start();
      this.service
        .getDrugList(
          this.clinicID,
          this.drugCategory,
          this.pageNumber,
          this.pageSize,
          searchItem
        )
        .subscribe((res: GlobalResponse) => {
          this.blockUI.stop();
          if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
            this.inventoryList = res.result.drugs;
            // console.log(this.inventoryList);
            this.length = res.result.drugsCount;
          }
        });
    }
  }

  searchItem() {
    if (this.searchBox && this.searchBox.length > 2) {
      this.delaySubject.next(this.searchBox);
    } else if (this.searchBox === '' || this.searchBox.length === 0) {
      this.categoryChanged(true);
    }
  }

  pageEvent(event) {
    // console.log(this.pageSize);
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.categoryChanged(false);
  }

  deleteItem(item: Drug) {
    this.blockUI.start();
    this.service.deleteDrugItem(item._id).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        // console.log(res.result);
        this.toastr.success(Constants.SUCCESS_ITEM_DELETED);
        this.categoryChanged(false);
      }
    });
  }

  addNewItem() {
    // console.log('editValues');
    // console.log(item);
    this.createDialogRef = this.dialog.open(CreateDrugDialogComponent, {
      disableClose: false,
    });
    this.createDialogRef.componentInstance.headerTitle = 'Add New Item';
    this.createDialogRef.componentInstance.doctorId =
      this.commonService.internalLoginValue._id;
    this.createDialogRef.componentInstance.clinicId = this.clinicID;
    // this.createDialogRef.componentInstance.batchFlag = false;
    this.createDialogRef.componentInstance.category = this.drugCategory;

    this.createDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // console.log('closed status');
        // console.log('closed status');
        // console.log(result);
        this.toastr.success('New item added Successfully');
        if (result.category) {
          this.drugCategory = result.category;
          this.categoryChanged(true);
        } else {
          this.categoryChanged(false);
        }
      }
      this.createDialogRef = null;
    });
  }

  bulkUpload() {
    this.uploadDialogRef = this.dialog.open(UploadDialogComponent, {
      disableClose: false,
    });

    this.uploadDialogRef.componentInstance.multipleFiles = false;
    this.uploadDialogRef.componentInstance.fileTypeAccepted =
      Constants.EXCEL_FILE_TYPE_SUPPORTED;

    this.uploadDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // console.log('uploaded');
        // console.log(result);
        if (result.length > 0) {
          this.blockUI.start();
          this.service.bulkUpload(result).subscribe(
            (res: GlobalResponse) => {
              this.blockUI.stop();
              // console.log(res);
              if (
                res &&
                res.message &&
                res.message === Constants.STATUS_SUCCESS
              ) {
                this.toastr.success(
                  Constants.STATUS_SUCCESS,
                  `Inventory Updated`
                );
                this.drugCategory = Constants.ALL_INVENTORY_VALUE;
                this.categoryChanged(true);
              }
            },
            (error) => {
              // console.log(error);
              this.toastr.error(
                Constants.LABEL_ERROR,
                Constants.ERROR_PERMISSION_NEEDED
              );
            }
          );
        }
      }
      this.uploadDialogRef = null;
    });
  }

  consumeItem() {
    this.consumeDialogRef = this.dialog.open(ConsumeDialogComponent, {
      disableClose: false,
    });
    this.consumeDialogRef.componentInstance.category = this.drugCategory;
    this.consumeDialogRef.componentInstance.clinicId = this.clinicID;

    this.consumeDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // console.log('closed status');
        this.blockUI.start();
        this.service
          .consumeDrug(this.clinicID, result.qty, result.itemId)
          .subscribe((res: GlobalResponse) => {
            this.blockUI.stop();
            if (
              res &&
              res.message &&
              res.message === Constants.STATUS_SUCCESS
            ) {
              // this.batches = res.result.batch;
              this.categoryChanged(false);
            }
          });
      }
      this.consumeDialogRef = null;
    });
  }

  getClinicList() {
    this.blockUI.start();
    this.service.getClinicList().subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        this.clinicList = res.result;
        if (this.clinicList && this.clinicList.length > 0) {
          this.clinic_selected = this.clinicList[0];
          this.clinicID = this.clinic_selected._id;
          this.categoryChanged(true);
        }
        // console.log(this.clinicList);
      }
    });
  }

  onClinicChange = (event) => {
    // console.log('clinic', event);
    // console.log(this.clinic_selected);
    if (
      this.clinic_selected &&
      this.clinic_selected.name &&
      this.clinic_selected.name !== undefined
    ) {
      this.clinicID = this.clinic_selected._id;
      this.searchBox = '';
      this.categoryChanged(true);
    }
  }
}
